import type { ComponentProps } from "react";

import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";

type ExportToDynamicsDropdownItemProps = Pick<
    ComponentProps<typeof ExportVariantsDropdownItem>,
    "isDisabled" | "isUseLockedIcon" | "text" | "tooltipContent" | "tooltipDisabledContent" | "onClick"
>;

const ExportToDynamicsDropdownItem = (props: ExportToDynamicsDropdownItemProps) => {
    return (
        <ExportVariantsDropdownItem
            {...props}
            iconName="dynamics"
            variant="dynamics"
        />
    );
};

export default ExportToDynamicsDropdownItem;
